import { Theme } from "@mui/material";

import makeStyles from '@mui/styles/makeStyles';
import { pprBorderColorA, gray2, textGrayB } from "../../DashStyleGuides";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    border: `1px solid ${pprBorderColorA}`,
    borderRadius: 12,
    height: 450,
  },
  title: {
    flex: "1 1 100%",
    fontWeight: "bold",
    fontFamily: "Manrope",
    fontSize: 16,
    color: textGrayB,
  },
  tblRoot: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
    height: 34,
  },
  lblNoData: {
    color: gray2,
    fontSize: 24,
    fontWeight: 400,
    marginTop: "12%",
  },
  bxFlexGrow: {
    flexGrow: 1,
  },
  orderWrapStyles: {
    position: "relative",
    height: 300,
    margin: 15,
  },
  barGraph: {},
}));
